module.exports = __webpack_public_path__ + "static/media/Large Square Frames with Oversized Mat_0007.4288f9ba.jpg";